(function () {
  const productSlider = () => {
    $(document).ready(function () {
      $(".js-get-section").each(function (index, parent) {
        let parentId = `#${$(parent).attr("id")}`;

        let carousel = document
          .querySelector(parentId)
          .querySelector(`.js-swiper-product-carousel`);

        let scrollBar = document
          .querySelector(parentId)
          .querySelector(`.js-product-carousel-swiper-scrollbar`);

        let prev = document
          .querySelector(parentId)
          .querySelector(`.js-product-carousel-arrow-prev`);

        let next = document
          .querySelector(parentId)
          .querySelector(`.js-product-carousel-arrow-next`);

        let freeModeMobile = parent.getAttribute("data-free-mode-mobile") === "true";
        let freeModeDesktop = parent.getAttribute("data-free-mode-desktop") === "true";

        let swiperConfig = {
          slidesPerView: 1.2,
          spaceBetween: 18,
          freeMode: freeModeMobile,
          breakpointsBase: 'container',
          scrollbar: {
            el: scrollBar,
            draggable: true,
          },
          navigation: {
            prevEl: prev,
            nextEl: next,
          },
          breakpoints: {
            500: {
              slidesPerView: 2,
              spaceBetween: 18,
              slidesOffsetAfter: 0,
              freeMode: freeModeDesktop
            },
            750: {
              slidesPerView: 3,
              spaceBetween: 18,
              slidesOffsetAfter: 0,
              freeMode: freeModeDesktop
            },
            1100: {
              slidesPerView: 4,
              spaceBetween: 18,
              slidesOffsetAfter: 0,
              freeMode: freeModeDesktop
            },
            1600: {
              slidesPerView: 5,
              spaceBetween: 18,
              slidesOffsetAfter: 0,
              freeMode: freeModeDesktop
            }
          },
        };

        let swiperCarousel = new Swiper(carousel, swiperConfig);

        if (
          $(".js-product-carousel-arrow-prev").hasClass("swiper-button-lock") ||
          $(".js-product-carousel-arrow-next").hasClass("swiper-button-lock")
        ) {
          $(".product-carousel_nav-tools").css("display", "none");
        }
      });
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    productSlider();
    document.addEventListener("shopify:section:load", function () {
      productSlider();
    });
  });
})();
